import { gsap } from 'gsap'
import lottie from 'lottie-web'
import { CustomEase } from 'gsap/CustomEase'
const SESSION_KEY = 'page-loader-shown'
gsap.registerPlugin(CustomEase)
CustomEase.create('loader', '0.65, 0.01, 0.05, 0.99')

const removeLoader = (loader) => {
    if (loader) {
        loader.remove()
    }
}

const hideLoader = (loader) => {
    const bg = loader.querySelector('[data-page-loader-bg]')

    if (!bg) {
        removeLoader(loader)
        return
    }

    let isCleanedUp = false

    const cleanup = () => {
        if (isCleanedUp) return

        isCleanedUp = true
        removeLoader(loader)
    }

    gsap.to(bg, {
        yPercent: -101,
        duration: 1,
        ease: 'loader',
        onComplete: cleanup
    })

    window.setTimeout(cleanup, 1400)
}

const init = () => {
    const loader = document.querySelector('[data-page-loader]')
    const hasSeenLoader = sessionStorage.getItem(SESSION_KEY) === 'true'

    if (hasSeenLoader) {
        // loader.remove()
        return
    }

    const lottieContainer = document.querySelector('[data-lottie-intro]')

    if (!loader) return

    if (!lottieContainer) {
        hideLoader(loader)
        return
    }

    const lottieAnim = lottie.loadAnimation({
        container: lottieContainer,
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path: '/assets/lottie/intro2.json'
    })

    let isFinished = false

    const finishLoader = () => {
        sessionStorage.setItem(SESSION_KEY, 'true')
        if (isFinished) return

        isFinished = true
        window.clearTimeout(fallbackTimeout)
        hideLoader(loader)
    }

    const fallbackTimeout = window.setTimeout(finishLoader, 6000)

    lottieAnim.addEventListener('complete', finishLoader)
    lottieAnim.addEventListener('data_failed', finishLoader)
}

init()
